export default __webpack_public_path__ + "static/media/health-app-img-old.cdf8c8b4.png";